import { RequestState } from '../../../types'

type AccountDetails = any

export type DetailsSettingsState = {
  accountDetails?: AccountDetails
  requestState: RequestState
}

export const initialDetailsSettingsState = {
  requestState: RequestState.NotLoaded
}